import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';

import Layout from '../pages/layout.vue';
import Error404 from '../pages/errors/404.vue';
import CvPage from '../pages/cv/index.vue';
import PhotoPage from '../pages/photo/index.vue';
import PreviewPage from '../pages/preview/index.vue';
import UserPage from '../pages/user/index.vue';

import store from '../store';
import * as ErrorStore from '../store/modules/error';

Vue.use(VueRouter);
Vue.use(VueMeta);

const pathPrefix = 'registration';
const routes = [
  {
    path: `/${pathPrefix}`,
    component: Layout,
    children: [
      {
        path: ``,
        name: 'home_path',
        redirect: {
          name: 'cv_path',
        },
      },
      {
        path: 'cv',
        component: CvPage,
        name: 'cv_path',
        meta: { title: '新規登録', desc: 'プロフの登録はこちらから。' },
      },
      {
        path: 'photo',
        component: PhotoPage,
        name: 'photo_path',
        meta: { title: '証明写真', desc: '' },
      },
      {
        path: 'preview',
        component: PreviewPage,
        name: 'preview_path',
        meta: { title: 'プレビュー', desc: '' },
      },
      {
        path: 'user',
        component: UserPage,
        name: 'user_path',
        meta: { title: '保存', desc: '' },
      },
      { path: '*', component: Error404, name: 'error_404' },
    ],
  },
];
const scrollBehavior = (_from, _to, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
};

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior,
});
router.beforeEach((_to, _from, next) => {
  store.dispatch(ErrorStore.ClearErrors.namespaced(null));
  next();
});

export default router;
